import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import Formsy, { addValidationRule } from 'formsy-react';
import React, { Component } from 'react'
import { Container, Search, Grid, Header, Segment, Button, Message, Table } from 'semantic-ui-react';
import { getSellerCategoryRadius, searchSubscribedSeller, saveSellerCategoryRadius } from 'services/Manager';
import './SellerCategoryRadiusContainer.less'
import { Input } from 'formsy-semantic-ui-react';
import { postiveNumber } from 'helpers/validation';

const inititalState = {
    sellers: [],
    selectedSeller: {},
    searchingSellers: false,
    searchSellerPhrase: '',
    sellerID: 0,
    categoryRadius: [],
    message: '',
    radiusVal: []
    
}

addValidationRule('isPositiveNumber', postiveNumber);
class SellerCategoryRadiusContainer extends Component {

    constructor(props) {
        super(props);
        this.state = inititalState;
    }

    componentDidMount() {

    }

    onSearchSellerChange = (e, { value }) => {
        this.setState({ searchSellerPhrase: value, searchingSellers: true });
        if (this.searchSellerTimer)
            clearTimeout(this.searchSellerTimer);

        this.searchSellerTimer = setTimeout(() => {
            if (this.state.searchSellerPhrase.length > 0) {
                searchSubscribedSeller(this.state.searchSellerPhrase).then((response) => {
                    if (response.resStatus === 200) {
                        let sellers = [];
                        response.data.map((seller) => {
                            sellers.push({ id: seller.sellerID, title: seller.name, seoName: seller.seoName });
                        })

                        this.setState({ sellers: sellers });
                    }

                    this.setState({ searchingSellers: false });

                });
            }
            else {
                this.setState({ sellers: [], selectedSeller: {}, searchingSellers: false });
            }
        }, 600)
    }

    onSellerSelect = async (e, { result }) => {
        this.setState({ sellerID: result.id, searchSellerPhrase: result.title, message: '' });
        await this.fetchSellerCategoryRadius(result.id);
        
    }

    fetchSellerCategoryRadius = async (sellerID) => {
        const res = await getSellerCategoryRadius(sellerID);
        if(res.resStatus == 200){
            this.setState({categoryRadius: res.data});
            let radiusVal = [];
            for(const cat of res.data){
                radiusVal.push({categoryID: cat.categoryID, radius: cat.serviceRadius})
            }
            this.setState({ radiusVal: radiusVal });
        }
    }

    onRadiusChange = (e, data, categoryID) => {
        const radiusVal = _.find(this.state.radiusVal, cat => cat.categoryID == categoryID);
        radiusVal.radius = data.value;
        this.setState({radiusVal: this.state.radiusVal});
        
    }

    onRadiusChangeSave = async () => {
        const res = await saveSellerCategoryRadius(this.state.sellerID, this.state.radiusVal);
        if(res.resStatus == 200){
            this.setState({message: 'Radius has been saved successfully'});
            await this.fetchSellerCategoryRadius(this.state.sellerID);
        }
        
    }

    render() {
        return (
            <Container fluid className="seller-category-radius-container">
                <div className="main-page-panel">
                    <div className="content-panel">
                        <div className="mobile-header">
                            <div className="main-heading">
                                Set Seller Category Radius
                            </div>
                        </div>
                        <Segment className="filter-segment">
                            <Formsy onValidSubmit={this.onSearch}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Header>Search Seller</Header>
                                            <Search
                                                fluid
                                                className="seller-search search-box"
                                                loading={this.state.searchingSellers}
                                                minCharacters={1}
                                                onSearchChange={this.onSearchSellerChange}
                                                results={this.state.sellers}
                                                onResultSelect={this.onSellerSelect}
                                                value={this.state.searchSellerPhrase}

                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Formsy>
                        </Segment>
                        {this.state.sellerID > 0 && 
                        <Segment>
                            <Formsy onValidSubmit={this.onRadiusChangeSave}>
                                <Grid>
                                    {this.state.message.length > 0 &&
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Message visible={this.state.message.length > 0} success>
                                                {this.state.message}
                                            </Message>
                                        </Grid.Column>
                                    </Grid.Row>
                                    }
                                    <Grid.Row>
                                        
                                            <Grid.Column width={16} >
                                            
                                                <Table basic celled padded striped >
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>
                                                                Category
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Radius
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Override Radius
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        {
                                                            _.map(this.state.categoryRadius, cr => {
                                                                const serviceRadius = _.find(this.state.radiusVal, cat => cat.categoryID == cr.categoryID);
                                                                
                                                                return <Table.Row>
                                                                <Table.Cell>
                                                                    {cr.categoryName}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {cr.serviceRadius}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    <Input 
                                                                    className='radius-field'
                                                                    name={`radius${cr.categoryID}`}
                                                                    placeholder="radius" 
                                                                    value={serviceRadius.radius} 
                                                                    onChange={(e, data) => this.onRadiusChange(e, data, serviceRadius.categoryID)}
                                                                    required
                                                                    validations={{
                                                                        isInt: true,
                                                                        isPositiveNumber: true
                                                                    }}
                                                                    validationErrors={{
                                                                        isInt: 'Invalid value.',
                                                                        isDefaultRequiredValue: 'This field is required',
                                                                        isPositiveNumber: 'Invalid value'
                                                                    }}
                                                                    errorLabel={<div className="error-label" />}
                                                                    /> 
                                                                </Table.Cell>
                                                            </Table.Row>
                                                            })
                                                        }
                                                        
                                                    </Table.Body>
                                                </Table>
                                                
                                            </Grid.Column>
                                        
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                        <button className="button-submit">Save</button>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                </Formsy>
                        </Segment>
    }
                    </div>
                </div>

            </Container>
        )
    }
}

export default SellerCategoryRadiusContainer